import { Box } from '@mui/material';
import styled from '@emotion/styled';
import { breakpoints, spacing } from '@/theme/tokens';

const StyledSidebar = styled(Box)`
    width: 220px;
    flex-shrink: 0;
    height: fit-content;

    @media (max-width: ${breakpoints.md}) {
        width: 200px;
    }

    @media (max-width: ${breakpoints.sm}) {
        width: 100%;
    }

    @media (min-width: ${breakpoints.md}) {
        margin-bottom: ${spacing[40]};
    }
`;

interface SidebarProps {
    children: React.ReactNode;
}

export default function Sidebar({ children }: SidebarProps) {
    return <StyledSidebar>{children}</StyledSidebar>;
}
